import { render, staticRenderFns } from "./RoundType.vue?vue&type=template&id=1d8797d5&"
import script from "./RoundType.vue?vue&type=script&lang=js&"
export * from "./RoundType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports